var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "choice",
    clipPath: "url(#clip0_109_418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49976 8.83813C7.49976 6.8667 9.10376 5.2627 11.0754 5.2627C13.0469 5.2627 14.6511 6.8667 14.6511 8.83813V11.7197C15.6443 11.416 16.3691 10.491 16.3691 9.39941V2.42578C16.3691 1.08813 15.2808 0 13.9431 0H8.20776C6.87012 0 5.78174 1.08813 5.78174 2.42578V9.39941C5.78174 10.491 6.50635 11.416 7.49976 11.7197V8.83813Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.8311 0H20.0955C18.7578 0 17.6697 1.08813 17.6697 2.42578V9.39941C17.6697 10.7371 18.7578 11.8252 20.0955 11.8252H25.8311C27.1687 11.8252 28.2571 10.7371 28.2571 9.39941V2.42578C28.2571 1.08813 27.1687 0 25.8311 0Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3882 15.0715C20.4387 15.0715 19.6694 15.8411 19.6694 16.7903V15.9148C19.6694 14.9656 18.8999 14.196 17.9504 14.196C17.0012 14.196 16.2317 14.9653 16.2317 15.9148V15.1785C16.2317 14.2756 15.5356 13.5361 14.6511 13.4656C14.6055 13.4622 14.5596 13.4597 14.5129 13.4597C13.8201 13.4597 13.2234 13.8701 12.9514 14.4607C12.8508 14.6792 12.7942 14.9221 12.7942 15.1785V8.83814C12.7942 7.88892 12.0247 7.11938 11.0754 7.11938C10.1262 7.11938 9.35669 7.88892 9.35669 8.83814V23.594L9.28222 23.5845L8.22338 19.0522C8.00732 18.1279 7.08276 17.5535 6.15844 17.7695C5.18774 17.7695 4.57421 18.543 4.79492 19.4883L6.0227 24.7429C6.66479 28.8542 9.98828 32 9.98828 32H20.4307C22.1755 29.3462 23.1055 26.2397 23.106 23.0635L23.1069 16.7903C23.1069 15.8411 22.3374 15.0715 21.3882 15.0715Z",
    fill: "#F8C200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoiceIcon);
export default __webpack_public_path__ + "static/media/choice-icon.b64ea53cf0a60a9d730b4b0ce3f8cd78.svg";
export { ForwardRef as ReactComponent };